import { User } from '../user';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class RegistrationSerializer extends BaseSerializer {
  deserialize(raw) {
    // Nouveau format: { statusCode: 201, message: "...", data: { user: {...} } }
    const success = raw?.statusCode === 201;
    let parsedUser = null;
    if (success && raw?.data) {
      const apiUser = raw.data;
      parsedUser = {
        id: apiUser.id || apiUser._id,
        email: apiUser.email,
        firstName: apiUser.firstName,
        lastName: apiUser.lastName,
        phoneNumber: apiUser.phoneNumber || apiUser.phone || '',
        countryCode: apiUser.countryCode,
        createdAt: apiUser.createdAt,
        updatedAt: apiUser.updatedAt,
        profilePictureUrl: apiUser.metadata?.avatar,
        referralCode: apiUser.referralCode,
        metadata: apiUser.metadata || { service: 'rapidoo' }
      };
    }

    const errorTexts = success
      ? null
      : errorMessages[`${raw?.statusCode}`] || errorMessages.other;
    return {
      success,
      statusCode: raw?.statusCode || 200,
      message: success ? 'ok' : errorTexts?.message,
      errorTitle: errorTexts?.title,
      alreadyExists: raw?.statusCode === 409,
      user: success ? new User(parsedUser) : null,
      token: null  // La nouvelle API ne renvoie pas de token
    };
  }

  serialize(data) {
    if (!data) return null;

    // Format conforme à la nouvelle API: séparer firstName et lastName
    const firstName = data.firstName?.trim() || '';
    const lastName = data.lastName?.trim() || '';

    // Build phone number with prefix if provided
    let phone = null;
    if (data.phonePrefix && data.phoneNumber) {
      phone = `${data.phonePrefix}${data.phoneNumber}`;
    }

    // Préparer le metadata avec whatsappNumber
    const metadata = {
      service: 'rapidoo'
    };

    // Ajouter whatsappNumber si disponible
    if (data.whatsappNumber) {
      metadata.whatsappNumber = data.whatsappNumber;
    }

    return {
      firstName,
      lastName,
      email: data.email ? `${data.email}`.toLowerCase() : null,
      password: data.password,
      phoneNumber: phone,
      countryCode: data.countryCode || 'BJ', // Valeur par défaut
      metadata
    };
  }
}
const errorMessages = {
  409: {
    title: 'Informations déjà utilisées',
    message:
      'Cet email ou ce numéro de téléphone est déjà associé à un compte. Veuillez vous connecter ou utiliser d\'autres identifiants.'
  },
  400: {
    title: 'Erreur dans les données',
    message:
      'Les informations soumises sont invalides. Veuillez vérifier et réessayer.'
  },
  other: {
    title: "Échec de l'inscription",
    message: 'Une erreur inattendue s’est produite. Veuillez réessayer.'
  }
};

export const registrationSerializer = new RegistrationSerializer();
